// material-ui
import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Grid,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemSecondaryAction,
  ListItemText,
  MenuItem,
  Stack,
  TextField,
  Typography,
  Collapse,
  Card,
  CardContent,
} from '@mui/material';
import "./Dashboard.scss";
import { formatDate, hideLoader, showLoader } from '../../../helpers/utils.js';
import { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import DashboardHelper from '../../components/cards/dashboard_helper/dashboard_helper_data.js';
import Divider from '@mui/material/Divider';
import { Link, useNavigate } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import MainCard from '../../components/MainCard.js';
import Paper from '@mui/material/Paper';
import { borderRadius, borderStyle } from '../../../plugins/tailwind/tailwind_classes.js';
import { getRequest } from '../../../helpers/request.js';
import { useSelector } from 'react-redux';
import infoImg from "../../../images/info.png";
import dashboard from './../../menu-items/dashboard';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import { connectSocket } from '../../../socket';
import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import notificationSound from "./notification.mp3";
import { useDispatch } from 'react-redux';
import AssistantModal from './AssistantModal';
// ==============================|| DASHBOARD - DEFAULT ||============================== //
const style = {
  width: '100%',
  maxWidth: 360,
  bgcolor: 'background.paper',
  borderRadius: '25px'
};

const DashboardDefault = () => {
  const [value, setValue] = useState('today');
  const [slot, setSlot] = useState('week');

  const [showDetails, setShowDetails] = useState(false);
  const [dspStats, setDspStats] = useState(null);

  const userStore = useSelector((state) => state.userStore);

  const [openPromptModal, setOpenPromptModal] = useState(false);
  const [showChatIcon, setShowChatIcon] = useState(true);
  const [userPrompt, setUserPrompt] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    // const sound = new Audio(notificationSound);
    // sound.play();

    setShowChatIcon(true);

    // Optional: Auto-open after a delay
    // setTimeout(() => setOpenPromptModal(true), 5000);
  }, []);

  const toggleInfo = () => {
    setShowDetails(!showDetails);
  };

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning";
    if (hour < 18) return "Good Afternoon";
    return "Good Evening";
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      console.error("No token found in localStorage. Please log in.");
      return;
    }
    const decoded = jwtDecode(token);
    // Connect to socket after successful login
    connectSocket(decoded.userId); //karthik 
    console.log("Socket connected successfully");
  }, []);

  useEffect(() => {
    let showStats = true;
    (async () => {
      showLoader();
      const response = await getRequest(`user/dsp-stats`);
      hideLoader();
      if (response.data.isSuccess) {
        if (showStats) {
          const stats = response.data.stats;
          setDspStats(stats);
        }
      } else {
        if (response.data.msg) alert(response.data.msg);
      }
    })();

    return () => {
      showStats = false;
    };
  }, []);

  return (
    dspStats && (
      <>
        <Grid container rowSpacing={4} columnSpacing={2.75}>
          {/* row 1 */}
          <Grid item xs={12} sx={{ mb: -2.25 }}>
            <Typography variant='h4' style={{ fontSize: 18, color: "#034EA2" }} mb={1}>
              Hey {getGreeting()} {userStore.name || 'User'}, Welcome to DSP-Editor
              <IconButton onClick={toggleInfo}>
                <InfoOutlinedIcon fontSize='very-small' /></IconButton>
              {/* <span className="circle"> */}
              {/* <img
                src={infoImg}
                onClick={toggleInfo}
                alt="toggle-info-icon"
                style={{
                  width: '25px', borderRadius: '50%', position: "absolute",
                  zIndex: "9"
                }} */}
              {/* /> */}
              {/* </span> */}
            </Typography>
            <Collapse in={showDetails} timeout="auto" unmountOnExit>
              <Card>
                <CardContent>
                  DSP-Builder which combines different tools and features with the goal to help you build DSPs slides and templates without any knowledge of coding. It's a perfect solution to replace the common WYSIWYG editors, which are good for content editing.
                </CardContent>
              </Card>
            </Collapse>
            {userStore.role === 'NEW' && <>
              <Typography variant='body1' style={{ fontSize: 18, color: "#ed0677" }}>New users need manager approval to access presentation.</Typography>
            </>}
          </Grid>

          <Grid item xs={4} sm={4} md={4} lg={4}>
            <DashboardHelper
              title='TOTAL PRESENTATIONS'
              count={dspStats.totalPresentations.toString()}
            />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4}>
            <DashboardHelper
              title='TOTAL IMPORTS'
              count={dspStats.totalImports.toString()}
              color='error'
            />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4}>
            <DashboardHelper
              title='TOTAL TEMPLATES'
              count={dspStats.totalTemplates.toString()}
              color='warning'
            />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4}>
            <DashboardHelper
              title='YOUR PRESENTATIONS'
              count={dspStats.userPresentations.toString()}
              color='success'
            />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4}>
            <DashboardHelper
              title='YOUR IMPORTS'
              count={dspStats.userImports.toString()}
              color='secondary'
            />
          </Grid>

          <Grid item xs={4} sm={4} md={4} lg={4}>
            <DashboardHelper
              title='YOUR TEMPLATES'
              count={dspStats.userTemplates.toString()}
              color='primary'
            />
          </Grid>

          <Grid item xs={4} sm={4} md={4} lg={4}>
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                '& > :not(style)': {
                  m: 1,
                  width: '100%',
                  heigth: '100%',
                },
              }}
            >
              <Paper elevation={1} sx={{ borderRadius: '25px' }}>
                <Typography
                  variant='h5'
                  color='inherit'
                  sx={{ ml: 0, pl: 1, pb: 1, pt: 1, textAlign: 'center' }}
                  style={{ color: 'white', backgroundColor: '#034EA2', borderTopRightRadius: "25px", borderTopLeftRadius: "25px" }}
                >
                  Today Activity
                </Typography>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <List sx={style} component='nav'>
                    {dspStats.todayActivities.map((keyMessage) => {
                      const keyMessageId = keyMessage._id;
                      const keyMessageName = keyMessage.name;
                      const updatedAt = formatDate(keyMessage.updatedAt);
                      const presentationId = keyMessage.presentation[0]._id;
                      const presentationName = keyMessage.presentation[0].name;
                      return (
                        <ListItem button divider>
                          <ListItemText
                            primary={
                              <Typography
                                variant='body1'
                                noWrap // Prevents text from wrapping to multiple lines
                                style={{
                                  whiteSpace: 'nowrap', // Prevents text from wrapping
                                  overflow: 'hidden', // Hides overflowed text
                                  textOverflow: 'ellipsis', // Adds an ellipsis (...) for overflowed text
                                }}
                              >
                                <Link
                                  key={`km-${keyMessageId}`}
                                  title={`${keyMessageName}: ${presentationName}, Last Update @ ${updatedAt}`}
                                  to={`/presentations/${presentationId}/key-messages`}
                                  className='list-group-item text-truncate'
                                >
                                  {/* {`${keyMessageName}${keyMessageName.toLowerCase().includes("shared") ? ` | Presentation: ${presentationName}` : ""}`} */}
                                  {`${keyMessageName} | Pres: ${presentationName}`}
                                </Link>
                              </Typography>
                            }
                          />
                        </ListItem>


                      );
                    })}
                  </List>
                </Grid>
                {/* <Typography variant="h6" color="inherit" sx={{ ml: 0, pl: 1 }}>Today Activity</Typography> */}
              </Paper>
            </Box>
          </Grid>

          <Grid item xs={4} sm={4} md={4} lg={4}>
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                '& > :not(style)': {
                  m: 1,
                  width: '100%',
                  heigth: '100%',
                },
              }}
            >
              <Paper elevation={1} sx={{ borderRadius: '25px' }}>
                <Typography
                  variant='h5'
                  color='inherit'
                  sx={{ ml: 0, pl: 1, pb: 1, pt: 1, textAlign: 'center' }}
                  style={{ color: 'white', backgroundColor: '#034EA2', borderTopRightRadius: "25px", borderTopLeftRadius: "25px" }}
                >
                  Latest Update
                </Typography>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <List sx={style} component='nav' aria-label='mailbox folders'>
                    {dspStats.latestUpdates.map((update, index) => (
                      // <Typography
                      //   variant='h6'
                      //   color='inherit'
                      //   sx={{ ml: 1, pl: 2.5, mt: 0.5, border: 'solid 1px' }}
                      //   className='list-group-item text-truncate'
                      //   title={update}
                      //   key={index}
                      // >
                      //   {update}
                      // </Typography>

                      <ListItem button divider>
                        <ListItemText
                          primary={
                            <Typography
                              variant='body1'
                              noWrap // Prevents text from wrapping to multiple lines
                              style={{
                                whiteSpace: 'nowrap', // Prevents text from wrapping
                                overflow: 'hidden', // Hides overflowed text
                                textOverflow: 'ellipsis', // Adds an ellipsis (...) for overflowed text
                              }}
                            >
                              {update}
                            </Typography>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </Grid>
                {/* <Typography variant="h6" color="inherit" sx={{ ml: 0, pl: 1 }}>Today Activity</Typography> */}
              </Paper>
            </Box>
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4}>
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                '& > :not(style)': {
                  m: 1,
                  width: '100%',
                  heigth: '100%',
                },
              }}
            >
              <Paper elevation={1} sx={{ borderRadius: '25px' }}>
                <Typography
                  variant='h5'
                  color='inherit'
                  sx={{ ml: 0, pl: 1, pb: 1, pt: 1, textAlign: 'center' }}
                  style={{ color: 'white', backgroundColor: '#034EA2', borderTopRightRadius: "25px", borderTopLeftRadius: "25px" }}
                >
                  Upcoming Features
                </Typography>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <List sx={style} component='nav'>
                    <ListItem button divider>
                      <ListItemText primary='Veeva integration' />
                    </ListItem>

                    <ListItem button divider>
                      <ListItemText primary='PDF,PPT to html' />
                    </ListItem>
                    <ListItem button divider>
                      <ListItemText primary='XD,figma to html' />
                    </ListItem>

                    <ListItem button divider>
                      <ListItemText primary='Auto generation of thumbnail' />
                    </ListItem>

                    <ListItem button divider>
                      <ListItemText primary='NLP' />
                    </ListItem>
                  </List>
                  {/* <Typography
                    variant='h6'
                    color='inherit'
                    sx={{ ml: 1, pl: 1, mt: 0.5 }}
                  >
                    Veeva integration
                  </Typography>
                  <Typography
                    variant='h6'
                    color='inherit'
                    sx={{ ml: 1, pl: 1, mt: 0.5 }}
                  >
                    PDF,PPT to html
                  </Typography>
                  <Typography
                    variant='h6'
                    color='inherit'
                    sx={{ ml: 1, pl: 1, mt: 0.5 }}
                  >
                    XD,figma to html
                  </Typography>
                  <Typography
                    variant='h6'
                    color='inherit'
                    sx={{ ml: 1, pl: 1, mt: 0.5 }}
                  >
                    Auto generation of thumbnail
                  </Typography>
                  <Typography
                    variant='h6'
                    color='inherit'
                    sx={{ ml: 1, pl: 1, mt: 0.5 }}
                  >
                    NLP
                  </Typography> */}
                </Grid>
                {/* <Typography variant="h6" color="inherit" sx={{ ml: 0, pl: 1 }}>Today Activity</Typography> */}
              </Paper>
            </Box>
          </Grid>

          {/* <Grid item md={8} sx={{ display: { sm: 'none', md: 'block', lg: 'none' } }} /> */}
        </Grid>
        {showChatIcon && userStore.NLP && (
          <Box
            onClick={() => {
              setOpenPromptModal(true);
              // setShowChatIcon(false);
            }}
            sx={{
              position: 'fixed',
              bottom: 24,
              right: 24,
              zIndex: 1300,
              backgroundColor: '#034EA2',
              color: 'white',
              padding: '12px 16px',
              borderRadius: '20px',
              display: 'flex',
              alignItems: 'center',
              boxShadow: 3,
              cursor: 'pointer',
              transition: 'transform 0.3s ease',
              '&:hover': { transform: 'scale(1.05)' },
            }}
          >
            <ChatBubbleOutlineIcon sx={{ mr: 1 }} />
            <Typography variant="body2">Ask something like “Create a presentation”</Typography>
          </Box>

        )}
        {openPromptModal &&
          <AssistantModal openPromptModal={openPromptModal}
            setOpenPromptModal={setOpenPromptModal} />
        }
      </>
    )
  );
};

export default DashboardDefault;
